import React, { memo } from 'react';
import { SlidersHorizontalIcons } from '../../../../../../icons/icons';
import { ActionButton } from './ActionButton';
import { TableViewControlsProps } from './interfaces';

export const TableViewControls = memo<TableViewControlsProps>(({ handleColumnConfig }) => (
  <ActionButton
      onClick={handleColumnConfig}
      icon={<SlidersHorizontalIcons className='w-3 sm:w-4 h-3 sm:h-4 group-hover:rotate-12 transition-transform duration-200' />}
      label='Columns'
      title='Configure table columns'
  />
));

TableViewControls.displayName = 'TableViewControls';
